/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Notes_Complete_LabelInputs */

const en_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes Complete`)
};

const fr_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes completees`)
};

const de_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen vollständig`)
};

const it_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note complete`)
};

const ru_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания завершены`)
};

const es_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas completas`)
};

const zh_cn2_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记已完成`)
};

const ja_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモ完了`)
};

const hi_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स पूरे`)
};

const pt_pt2_event_notes_notes_complete_label = /** @type {(inputs: Event_Notes_Notes_Complete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas concluídas`)
};

/**
* | output |
* | --- |
* | "Notes Complete" |
*
* @param {Event_Notes_Notes_Complete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_notes_complete_label = /** @type {((inputs?: Event_Notes_Notes_Complete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Notes_Complete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_notes_complete_label(inputs)
	if (locale === "de") return de_event_notes_notes_complete_label(inputs)
	if (locale === "it") return it_event_notes_notes_complete_label(inputs)
	if (locale === "ru") return ru_event_notes_notes_complete_label(inputs)
	if (locale === "es") return es_event_notes_notes_complete_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_notes_complete_label(inputs)
	if (locale === "ja") return ja_event_notes_notes_complete_label(inputs)
	if (locale === "hi") return hi_event_notes_notes_complete_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_notes_complete_label(inputs)
	return en_event_notes_notes_complete_label(inputs)
});